import React, { useMemo, useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import InfluencerContractPendingListRead from '../../components/admin/influencer/InfluencerContractPendingListRead';
import '../../styles/admin/AdminSummary.css';

const API_URL = process.env.REACT_APP_API_URL;

function InfluencerFreeContractPage() {
  const [selected, setSelected] = useState(null);      // 좌측에서 고른 요약 객체
  const [detail, setDetail] = useState(null);          // 우측 상세
  const [loading, setLoading] = useState(false);
  const [refreshToken, setRefreshToken] = useState(0); // ← 리스트 갱신 트리거 (완료/리셋 시 사용)

  useEffect(() => {
    const targetId = selected?._id || selected?.userId;
    if (!targetId) { setDetail(null); return; }
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_URL}/api/influencer/${targetId}`, { credentials: 'include' });
        const data = await res.json();
        if (res.ok) setDetail(data); else setDetail(null);
      } catch { setDetail(null); }
      setLoading(false);
    })();
  }, [selected]);

  const sns = useMemo(() => {
    const get = (p) => detail?.snsInfo?.find(s => s.platform === p)?.accountName || '';
    return { tiktok: get('tiktok'), instagram: get('instagram'), blog: get('blog'), youtube: get('youtube') };
  }, [detail]);


  // 계약 완료 처리
  const handleContractComplete = async () => {
    if (!selected) return;
    const id = selected._id || selected.userId;
    const ok = window.confirm('계약을 완료 상태로 처리하시겠습니까?');
    if (!ok) return;
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/influencer/${id}/contract/complete`, {
        method: 'POST',
        credentials: 'include'
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        setSelected(null);
        setDetail(null);
        setRefreshToken(t => t + 1); // 좌측 목록 새로고침(사라짐)
      } else {
        alert(data.message || '계약 완료 처리 실패');
      }
    } catch {
      alert('계약 완료 처리 요청 실패');
    }
    setLoading(false);
  };

  // 목록에서 삭제(리셋)
  const handleContractReset = async () => {
    if (!selected) return;
    const id = selected._id || selected.userId;
    const ok = window.confirm('목록에서 삭제(초기화) 하시겠습니까? 이력은 초기 상태(none)로 돌아갑니다.');
    if (!ok) return;
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/influencer/${id}/contract/reset`, {
        method: 'POST',
        credentials: 'include'
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        setSelected(null);
        setDetail(null);
        setRefreshToken(t => t + 1); // 좌측 목록 새로고침(사라짐)
      } else {
        alert(data.message || '목록 삭제(초기화) 실패');
      }
    } catch {
      alert('목록 삭제(초기화) 요청 실패');
    }
    setLoading(false);
  };

  return (
    <AdminLayout title="프리랜서 계약 관리">
      <div className="admin-grid">
        <div className="admin-section" style={{ height: 'calc(100vh - 120px)' }}>
          <InfluencerContractPendingListRead
            onSelect={(u) => setSelected(u)}
            selectedId={selected?._id || selected?.userId}
            refreshToken={refreshToken}
          />
        </div>

        <div className="admin-section admin-section--wide" style={{ height: 'calc(100vh - 120px)', overflowY: 'auto' }}>
          <h3 className="admin-summary__title">인플루언서 상세 정보</h3>
          {loading && <div className="admin-summary__loading">불러오는 중...</div>}
          {!loading && !detail && <div className="admin-summary__empty" style={{ marginTop: '20px' }}>좌측에서 인플루언서를 선택하세요.</div>}

          {!loading && detail && (
            <>
              <div style={{ lineHeight: 2, fontSize: '14px', color: 'var(--admin-text-body)' }}>
                <div><strong>인플루언서 ID</strong>: {detail.userId}</div>
                <div><strong>이름</strong>: {detail.userName}</div>
                <div><strong>연락처</strong>: {detail.phoneNumber}</div>
                <div><strong>메일</strong>: {detail.email}</div>
                <div><strong>주소</strong>: {detail.userAddress}</div>
                <div><strong>SNS 계정(틱톡)</strong>: {sns.tiktok}</div>
                <div><strong>SNS 계정(인스타)</strong>: {sns.instagram}</div>
                <div><strong>SNS 계정(블로그)</strong>: {sns.blog}</div>
                <div><strong>SNS 계정(유튜브)</strong>: {sns.youtube}</div>
              </div>

              <div className="admin-section__actions" style={{ justifyContent: 'flex-end', marginTop: 20 }}>
                <button 
                  className="admin-section__button" 
                  type="button" 
                  onClick={handleContractReset} 
                  disabled={loading}
                  style={{ backgroundColor: loading ? '#ef9a9a' : 'var(--admin-color-danger)', borderColor: loading ? '#ffcdd2' : 'var(--admin-color-danger)' }}
                >
                  목록에서 삭제
                </button>
                <button 
                  className="admin-section__button" 
                  type="button" 
                  onClick={handleContractComplete} 
                  disabled={loading}
                  style={{ backgroundColor: loading ? '#b2dfdb' : 'var(--admin-color-success)', borderColor: loading ? '#80cbc4' : 'var(--admin-color-success)' }}
                >
                  계약 완료 처리
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}

export default InfluencerFreeContractPage;